<script>
import {Popup} from "vant";
import {dataBuryingPoint, gotoNative} from "@/utils/JSBridge";
import {isClient} from "@/utils/isTerminal";
import {hsjH5BurialPoint} from "@/utils/shareCommon";
import {preBuyCheckCourseOrder} from "@/api/order";

export default {
  name: "ZN10Popup",
  components: {Popup},
  props: {
    //主动触发验证
    validate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show:false,
    }
  },
  methods: {
    kf(){
      if(isClient){
        gotoNative("nurse://weixin.kf?url=https://work.weixin.qq.com/kfid/kfcfb26ee166a623add")
        setTimeout(()=>{
          dataBuryingPoint("B000005", "B000005-316", {id:  window.PAGE_PARAMS.courseId,});
        },600)
      }else {
        hsjH5BurialPoint("B000026", "B000026-316", { id: window.PAGE_PARAMS.courseId });
        window.location.href = "https://work.weixin.qq.com/kfid/kfcfb26ee166a623add"
      }
    },
    validateCourse(courseId,successCallback){
      preBuyCheckCourseOrder({id: courseId}).then(r=>{
        if(r){
          this.show = true
          if(isClient){
            setTimeout(()=>{
              dataBuryingPoint("B000005", "B000005-400", {id:  window.PAGE_PARAMS.courseId,});
            },600)
          }else {
            hsjH5BurialPoint("B000026", "B000026-400", { id: window.PAGE_PARAMS.courseId });
          }
        }else {
          successCallback()
        }
      })
    }
  },
  created() {
    if(this.validate){
      return
    }
    preBuyCheckCourseOrder({id: window.PAGE_PARAMS.courseId}).then(r=>{
      if(r){
        this.show = true
        if(isClient){
          setTimeout(()=>{
            dataBuryingPoint("B000005", "B000005-318", {id:  window.PAGE_PARAMS.courseId,});
          },600)
        }else {
          hsjH5BurialPoint("B000026", "B000026-318", { id: window.PAGE_PARAMS.courseId });
        }
      }
    })
  }
}
</script>

<template>
  <Popup
      style="background: transparent"
      :value="show"
      :close-on-click-overlay="false">
    <div class="ZN10Popup">
      <img src="./tip.png" alt="">
      <div class="btn10" @click="kf"></div>
    </div>
  </Popup>
</template>

<style scoped lang="scss">
.ZN10Popup{
  width: 90vw;
  position: relative;
  img{
    width: 100%;
  }
  .btn10{
    position: absolute;
    width:82%;
    height: 50px;
    bottom: 84px;
    left:10%;
  }
}
</style>